// @owner ClientPlatform

export function classNames(obj: object) {
  return Object.entries(obj)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(' ');
}
